import {
  DocumentReference,
  INamedDocument,
  isDocRef,
  isINamedDocument,
  ISoftDelete,
  isTimestamp,
  Region,
  Timestamp,
  TypeGuard,
} from '@principle-theorem/shared';
import { isBoolean, isString } from 'lodash';
import { IBrand } from '../brand';
import { IOrganisation } from '../organisation/organisation';
import { IStaffer } from '../staffer/staffer';

export enum WorkspaceProvisioningTaskStatus {
  Pending = 'pending',
  Completed = 'completed',
}

export const WORKSPACE_PROVISIONING_TASK_STATUS_COLOUR_MAP: {
  [key in WorkspaceProvisioningTaskStatus]: string;
} = {
  [WorkspaceProvisioningTaskStatus.Pending]: 'default',
  [WorkspaceProvisioningTaskStatus.Completed]: 'success',
};

export interface IWorkspaceProvisioningTask extends ISoftDelete {
  clickUp: {
    taskId: string;
    taskUrl: string;
    taskName: string;
    country: string;
  };
  status: WorkspaceProvisioningTaskStatus;
  accountManagers?: DocumentReference<IStaffer>[];
  selectedOrganisationRef?: DocumentReference<IOrganisation>;
  newOrganisationName?: string;
  selectedBrandRef?: DocumentReference<IBrand>;
  newBrandName?: string;
  practiceName: string;
  region?: Region;
  seedFileName?: string;
  completedAt?: Timestamp;
  completedBy?: INamedDocument<IStaffer>;
}

export interface ICompleteProvisioningTaskRequest {
  provisioningTaskRef: DocumentReference<IWorkspaceProvisioningTask>;
  completedBy: INamedDocument<IStaffer>;
}

export interface ICompleteProvisioningTaskResponse {
  success: boolean;
  practiceId: string;
  workspaceUrl: string;
}

export const isWorkspaceProvisioningTask =
  TypeGuard.interface<IWorkspaceProvisioningTask>({
    clickUp: TypeGuard.interface({
      taskId: isString,
      taskUrl: isString,
      taskName: isString,
      country: isString,
    }),
    status: TypeGuard.enumValue(WorkspaceProvisioningTaskStatus),
    accountManagers: TypeGuard.nilOr(TypeGuard.arrayOf(isDocRef)),
    selectedOrganisationRef: TypeGuard.nilOr(isDocRef),
    newOrganisationName: TypeGuard.nilOr(isString),
    selectedBrandRef: TypeGuard.nilOr(isDocRef),
    newBrandName: TypeGuard.nilOr(isString),
    practiceName: isString,
    region: TypeGuard.nilOr(TypeGuard.enumValue(Region)),
    seedFileName: TypeGuard.nilOr(isString),
    completedAt: TypeGuard.nilOr(isTimestamp),
    completedBy: TypeGuard.nilOr(isINamedDocument),
    deleted: isBoolean,
  });
